import { User } from '@utils/backend-api/currentUser';

export function userName(user: Pick<User, 'name' | 'username'>) {
  return user.name || user.username;
}
